// █▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀▀█
// █        JESSE STEWART         █
// █        UX/UI Designer        █
// █     www.JesseStewart.com     █
// █                              █
// █   (c) All Rights Reserved    █
// █▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄▄█

import React from "react";
/** @jsx jsx */ import { css, jsx } from "@emotion/core";
import styled from "@emotion/styled";
import {
  // Import Const
  fonts,
  sizes,
  // Import Functions
  typeSet,
  borderRadius,
  padding,
  expandValue,
  transition
} from "../../helpers/theme";

var tinycolor = require("tinycolor2");

let buttonStyles = props => css`
  color: ${tinycolor
    .mostReadable(
      tinycolor(props.theme.colors.button1)
        .darken(15)
        .toString(),
      [props.theme.colors.white, props.theme.colors.black],
      { level: "AAA", size: "large" }
    )
    .toString()};
  border: 0;
  background-color: ${props.theme.colors.button1};
  font-family: ${fonts.default};
  ${typeSet(sizes.fontSize)}
  ${borderRadius(sizes.space * 0.25)}
  ${padding(
    "all",
    expandValue((sizes.space + sizes.cap) * 0.5) +
      " " +
      expandValue(sizes.space * 2) +
      " " +
      expandValue((sizes.space - sizes.cap) * 0.5)
  )}
  ${transition("all", sizes.timer + "ms")}
  cursor: pointer;
  position: relative;
  font-weight: 600;
  box-shadow: 0 ${expandValue(sizes.space * 0.062)} ${expandValue(
  sizes.space * 0.125
)} ${tinycolor(props.theme.colors.secondary)
  .setAlpha(0.2)
  .toString()}, inset 0 0 ${expandValue(sizes.space * 0.5)} ${tinycolor(
  props.theme.colors.button1
)
  .lighten(10)
  .brighten(7.5)
  .setAlpha(0.6)
  .toString()};
  text-shadow: 1px 1px 1px ${tinycolor(props.theme.colors.button1)
    .darken(20)
    .setAlpha(0.4)
    .toString()};
  margin-right: ${expandValue(sizes.space * 0.5)};
  margin-bottom: ${expandValue(sizes.space * 0.5)};
  &:hover {
    color: ${tinycolor
      .mostReadable(
        tinycolor(props.theme.colors.button1)
          .darken(15)
          .toString(),
        [props.theme.colors.white, props.theme.colors.black],
        { level: "AAA", size: "large" }
      )
      .toString()};
    background-color: ${tinycolor(props.theme.colors.button1)
      .lighten(5)
      .brighten(10)
      .setAlpha(0.6)
      .toString()};
    box-shadow: 0 ${expandValue(sizes.space * 0.062)} ${expandValue(
  sizes.space
)} ${tinycolor(props.theme.colors.primary)
  .setAlpha(0.4)
  .toString()}, inset 0 0 ${expandValue(sizes.space)} ${tinycolor(
  props.theme.colors.button1
)
  .lighten(10)
  .brighten(7.5)
  .setAlpha(0.6)
  .toString()};
  }
`;
let ButtonStyled = styled("button")`
  ${buttonStyles}
`;

export class Button extends React.Component {
  render() {
    return (
      <ButtonStyled>
        <span>{this.props.children}</span>
      </ButtonStyled>
    );
  }
}

let ButtonSecondaryStyles = props => css`
  color: ${tinycolor(props.theme.colors.button2)
    .lighten(15)
    .brighten(15)
    .toString()};
  border: 0;
  background: transparent;
  font-family: ${fonts.default};
  ${typeSet(sizes.fontSize)}
  ${borderRadius(sizes.space * 0.25)}
  ${padding(
    "all",
    expandValue((sizes.space + sizes.cap) * 0.5) +
      " " +
      expandValue(sizes.space * 2) +
      " " +
      expandValue((sizes.space - sizes.cap) * 0.5)
  )}
  ${transition("all", sizes.timer + "ms")}
  cursor: pointer;
  position: relative;
  font-weight: 600;
  box-shadow: 0 ${expandValue(sizes.space * 0.062)} ${expandValue(
  sizes.space * 0.125
)} ${tinycolor(props.theme.colors.secondary)
  .setAlpha(0.2)
  .toString()}, inset 0 0 ${expandValue(sizes.space * 0.5)} ${tinycolor(
  props.theme.colors.secondary
)
  .setAlpha(0.2)
  .toString()}, inset 0 0 0 1px ${props.theme.colors.button2};
  text-shadow: 1px 1px 1px ${tinycolor(props.theme.colors.button1)
    .darken(20)
    .setAlpha(0.4)
    .toString()};
  margin-right: ${expandValue(sizes.space * 0.5)};
  margin-bottom: ${expandValue(sizes.space * 0.5)};
  &:hover {
    color: ${tinycolor(props.theme.colors.button2)
      .lighten(10)
      .brighten(10)
      .toString()};
    box-shadow: 0 ${expandValue(sizes.space * 0.062)} ${expandValue(
  sizes.space
)} ${tinycolor(props.theme.colors.button2)
  .setAlpha(0.2)
  .toString()}, inset 0 0 ${expandValue(sizes.space)} ${tinycolor(
  props.theme.colors.button2
)
  .setAlpha(0.2)
  .toString()}, inset 0 0 0 1px ${tinycolor(props.theme.colors.button2)
  .lighten(15)
  .toString()};
  }
`;
let ButtonSecondaryStyled = styled("button")`
  ${ButtonSecondaryStyles}
`;

export class ButtonSecondary extends React.Component {
  render() {
    return (
      <ButtonSecondaryStyled>
        <span>{this.props.children}</span>
      </ButtonSecondaryStyled>
    );
  }
}

let buttonSetStyles = props => css`
  margin-bottom: ${expandValue(sizes.space * 0.5)};
`;
let ButtonSetStyled = styled("div")`
  ${buttonSetStyles}
`;

export class ButtonSet extends React.Component {
  render() {
    return (
      <ButtonSetStyled>
        <span>{this.props.children}</span>
      </ButtonSetStyled>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Partials/Button.js